<template>
	<div>
		<div class="box-tahapan"
		     v-for="(t, i) in tahapan"
		     :key="t.idtahapan"
		     :class="{'box-tahapan-top' : i === 0, 'box-tahapan-bottom' : i === tahapan.length - 1}"
		>
			<div class="d-flex-between-center p-x-16 p-y-12 align-items-center" @click="expand(t.idtahapan)">
				<div class="f-regular f-16 f-c-black">{{ t.text }}</div>
				<div class="d-flex align-items-center">
					<span class="badge color-blue m-r-12"
					      v-if="upah[t.idtahapan].percent.raw > 0"
					>
						Diatur
					</span>
					<div
						class="fas fa-chevron-down f-c-midgrey"
						:id="'chev-' + t.idtahapan"
						:class="{'chev-180' : isVisible[t.idtahapan]}"
					></div>
				</div>
			</div>
			<div style="display: none" :id="'form-tahapan-' + t.idtahapan">
				<div class="d-flex p-x-16 p-d-20">
					<div class="p-r-12" style="width: 65%">
						<InputRupiah
							:outerDivClass="'input-group remove-padding'"
							:showRp="true"
							:placeholder="'14.000'"
							:comma="false"
							:id="'input-tahapan-' + t.idtahapan"
							:customObject="upah[t.idtahapan].rupiah"
							:defaultValue="upah[t.idtahapan].rupiah.formatted"
							:maxAmount="hargaLayanan"
							v-model="upah[t.idtahapan].rupiah"
							@input="(val) => { convertingToPercent(t.idtahapan, val) }"
						/>
						<div class="f-regular f-12 f-c-midgrey">
							*Dalam rupiah
						</div>
					</div>
					<div style="width: 35%">
						<div class="input-group remove-padding">
							<InputPersentase
								class="'form-control inputs'"
								:id="'input-persentase-tahapan-' + t.idtahapan"
								v-model="upah[t.idtahapan].percent.formatted"
								:default-value="upah[t.idtahapan].percent.formatted"
								@input="(val) => { convertingToRupiah(t.idtahapan, val) }"
							/>
							<div class="input-group-prepend">
								<div class="input-group-text">%</div>
							</div>
						</div>
						<div class="f-regular f-12 f-c-midgrey">
							*Dalam persen
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import InputRupiah from "@/component-items/InputRupiah";
import InputPersentase from "@/component-items/InputPersentase";

export default {
	name: "UpahBoronganComponentV2",
	components: {
		InputRupiah,
		InputPersentase,
	},
	props: {
		hargaLayanan: Number,
		tahapan: Array,
		upahBorongan: Object,
	},
	data() {
		return {
			isVisible: {},
			upah: {},
			mode: {
				rupiah: false,
				percent: false,
			}
		}
	},
	mounted() {
		this.setup()
	},
	watch: {
		hargaLayanan: {
			handler: function () {
				this.recalculate()
			}
		},
		tahapan: {
			handler: function () {
				this.setup()
			},
			deep: true
		},
		upahBorongan: {
			handler: function () {
				this.setup()
			},
			deep: true
		},
	},
	methods: {
		setup() {
			this.setDataUpah()
			this.$emit("upah", this.upah)
		},
		setDataUpahDefault() {
			for (let i = 0; i < this.tahapan.length; i++) {
				this.upah[this.tahapan[i].idtahapan] = {
					rupiah: {
						idtahapan: this.tahapan[i].idtahapan,
						text: this.tahapan[i].text,
						value: 0,
						raw: 0,
						formatted: "0",
					},
					percent: {
						idtahapan: this.tahapan[i].idtahapan,
						text: this.tahapan[i].text,
						value: 0,
						raw: 0,
						formatted: "0",
					}
				}
				this.isVisible[this.tahapan[i].idtahapan] = false;
			}
		},
		setDataUpah() {
			if (this.upahBorongan !== undefined) {
				let newUpah = {}
				for (let i = 0; i < this.tahapan.length; i++) {
					if (this.upahBorongan[this.tahapan[i].idtahapan] === undefined) {
						// run fallback
						this.setDataUpahDefault()
						this.recalculate()
						return
					}

					newUpah[this.tahapan[i].idtahapan] = {
						rupiah: {
							idtahapan: this.upahBorongan[this.tahapan[i].idtahapan].idtahapan,
							text: this.upahBorongan[this.tahapan[i].idtahapan].text,
							value: this.upahBorongan[this.tahapan[i].idtahapan].value,
							raw: this.percentToRupiah(this.hargaLayanan, parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw)),
							formatted: this.percentToRupiah(this.hargaLayanan, parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw)).toString(),
						},
						percent: {
							idtahapan: this.upahBorongan[this.tahapan[i].idtahapan].idtahapan,
							text: this.upahBorongan[this.tahapan[i].idtahapan].text,
							value: this.upahBorongan[this.tahapan[i].idtahapan].value,
							raw: parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw),
							formatted: this.upahBorongan[this.tahapan[i].idtahapan].formatted,
						}
					}

					if (parseFloat(this.upahBorongan[this.tahapan[i].idtahapan].raw) !== 0) {
						$("#form-tahapan-" + this.tahapan[i].idtahapan).show();
						// $("#tahapan-" + this.tahapan[i].idtahapan).hide();
						this.isVisible[this.tahapan[i].idtahapan] = true
					} else {
						this.isVisible[this.tahapan[i].idtahapan] = false
					}
				}
				this.upah = newUpah;
			} else {
				this.setDataUpahDefault()
			}
		},
		setHargaLayanan(harga) {
			this.hargaLayanan = harga
		},

		expand(id) {
			$("#form-tahapan-" + id).slideToggle(300);
			this.isVisible[id] = !this.isVisible[id]
			if (this.isVisible[id]) {
				$("#chev-" + id).addClass("chev-180");
				$("#chev-" + id).removeClass("chev-0");
			} else {
				$("#chev-" + id).removeClass("chev-180");
				$("#chev-" + id).addClass("chev-0");
			}
		},

		removeUpahBorongan(id) {
			$("#tahapan-" + id).show();
			$("#form-tahapan-" + id).hide();

			this.upah[id].percent.formatted = "0"
			this.upah[id].percent.raw = 0
			this.upah[id].rupiah.formatted = "0"
			this.upah[id].rupiah.raw = 0
		},
		convertingToRupiah(id, val) {
			if (this.mode.rupiah) {
				return
			}
			if (!this.mode.percent) {
				this.mode.rupiah = false
				this.mode.percent = true
                setTimeout(() => {
                    this.mode.percent = false
                }, 1000)
			}

			let cloneUpah = JSON.parse(JSON.stringify(this.upah))
			cloneUpah[id].percent.formatted = val.formatted
			cloneUpah[id].percent.raw = val.raw

			cloneUpah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, val.raw).toString().replace(".", ",")
			cloneUpah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, val.raw)

			this.upah = cloneUpah
			this.$emit("upah", this.upah)
		},
		convertingToPercent(id, val) {
			if (this.mode.percent) {
				return
			}
			if (!this.mode.rupiah) {
				this.mode.rupiah = true
				this.mode.percent = false
                setTimeout(() => {
                    this.mode.rupiah = false
                }, 1000)
			}

			let cloneUpah = JSON.parse(JSON.stringify(this.upah))
			cloneUpah[id].percent.formatted = this.rupiahToPrecent(this.hargaLayanan, val.raw).toString().replace(".", ",")
			cloneUpah[id].percent.raw = this.rupiahToPrecent(this.hargaLayanan, val.raw)

			cloneUpah[id].rupiah.formatted = val.formatted
			cloneUpah[id].rupiah.raw = val.raw

			this.upah = cloneUpah
			this.$emit("upah", this.upah)
		},
		recalculate() {
			for (let i = 0; i < this.tahapan.length; i++) {
				let id = this.tahapan[i].idtahapan
				// acuan persen

				this.upah[id].rupiah.formatted = this.percentToRupiah(this.hargaLayanan, this.upah[id].percent.raw).toString().replace();
				this.upah[id].rupiah.raw = this.percentToRupiah(this.hargaLayanan, this.upah[id].percent.raw)
			}
		},

		rupiahToPrecent(harga, upah) {
			let fUpah = parseFloat(upah)
			let fHarga = parseFloat(harga)
			return (isNaN(fUpah)) ? 0 : parseFloat((fUpah / fHarga * 100).toFixed(2))
		},
		percentToRupiah(harga, upah) {
			let fUpah = parseFloat(upah)
			let fHarga = parseFloat(harga)
			return (isNaN(fUpah)) ? 0 : Math.round((fUpah / 100) * fHarga)
		},
	}
}
</script>

<style>
.box-tahapan {
	border: 1px solid #EDEDED;
}

.box-tahapan-top {
	border-top-left-radius: 4px;
	border-top-right-radius: 4px;
}

.box-tahapan-bottom {
	border-bottom-left-radius: 4px;
	border-bottom-right-radius: 4px;
}

.chev-0 {
	transform: rotate(0deg);
	transition: ease-in-out 300ms;
}

.chev-180 {
	transform: rotate(180deg);
	transition: ease-in-out 300ms;
}
</style>